import { selectBrokerProducts } from '../../../../../store/selectors/brokerProducts';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { resources } from './data';
import Pane from '../../components/Pane';
import Headline from '../../components/Headline';
import Description from '../../components/Description';
import { Fragment } from 'react';
import { mapTypeToTranslation } from './helpers';

const Plugins = () => {
  const { formatMessage } = useIntl();
  const brokerProducts = useSelector(selectBrokerProducts);
  const hasUserProducts = brokerProducts?.data.map(({ product }) => product);

  const renderPluginBoxes = (resources) =>
    resources
      .filter(({ product }) => product.filter((element) => element.includes(hasUserProducts)))
      .map(({ id, logo, title, description, link: { type, url } }) => (
        <Pane key={id} padding='none' radius={20} margin={20}>
          <div className='integration__plugins--logo'>
            <img src={logo} height={24} />

            <div className='integration__plugins--action'>
              <a href={url} target='_blank' rel='noopener noreferrer'>
                {mapTypeToTranslation(type, formatMessage)}
              </a>
            </div>
          </div>

          <div className='integration__plugins--body'>
            <Headline message={title} size={16} />

            <Description message={description} />
          </div>
        </Pane>
      ));

  return (
    <Fragment>
      <Headline message='Plugins headline' />

      <Description message='Plugins intro' />

      <div style={{ height: '30px' }} />

      {hasUserProducts ? renderPluginBoxes(resources) : null}
    </Fragment>
  );
};

export default Plugins;
